import { styled } from '@mui/material';
import { ReactComponent as IconVisa } from '../../../assets/images/visa.svg';

export const StyledIconVisa = styled(IconVisa)(() => ({
  height: '60px',
  width: '60px',
}));
